import snsAxiosClient from '../common/http/http-sns';
import { get } from 'lodash';

function storeLocator(environmentVariables, user, queryParams) {
  const options = {
    headers: {
      ...get(environmentVariables, 'STORE_LOOKUP_API_HEADERS_GET_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).get(
    `${get(environmentVariables, 'STORE_LOCATOR_API', 'store_locator')}?${queryParams}`,
  );
}

export default storeLocator;
